<i mui-icon font="fa" [iconStyle]="iconStyle" [name]="icon" class="mui-fab__icon"></i>
